<template>
  <!-- <a href=""  @click="getIndexActivity">获取主页的列表</a> -->
  <div class="act-wrap">
    <ul class="active_all">
      <li class="active_area" v-for="item in homeData" :key="item.id">
        <router-link :to="`/activity/detail/${item.id}`">
          <div class="active_image_area">
            <img :src="item.image" />
          </div>
          <div class="active_text_area">
            <div class="active_text_one">
              {{ item.title }}
            </div>
            <div class="active_text_two">
              <text style="font-size: 20px"></text>
              {{ $formatPrice(item.price_range_min, item.price_range_max_weapp, item.type) }}
            </div>
            <div class="active_text_three">{{ $formatDate(item.bm_start, item.bm_end) }}</div>
          </div>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      homeData: [],
    };
  },
  created() {
    this.getIndexActivity();
  },
  methods: {
    getIndexActivity() {
      // console.log('获取活动的内容');
      this.$get({
        road: 'indexActivity',
      }).then(res => {
        if (res.code === 0) {
          this.homeData = res.data;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
img {
  width: 100%;
  height: 100%;
}

.act-wrap {
  background: linear-gradient(178.81deg, #ffffff -88.39%, #f3f3f3 98.98%);
  padding: 24px;
  padding-bottom: 0;
}
.active_all {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.active_area {
  width: 341px;
  height: 507px;
  border-radius: 12px;
  overflow: hidden;
}

.active_image_area {
  width: 100%;
  height: 330px;
  overflow: hidden;
  border-radius: 8px;
}

.active_image_area image {
  width: 100%;
  height: 100%;
  border-radius: 12px 12px 0px 0px;
}

.active_text_area {
  padding: 20px;
  background: #fff;
  border-radius: 0px 0px 12px 12px;
}

.active_text_one {
  font-family: PingFang SC;
  font-size: 28px;
  line-height: 42px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.active_text_two {
  font-family: DIN Alternate;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 42px;
  color: #e15443;
}

.active_text_three {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 30px;
  color: #818181;
}
</style>
